import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';
import { Link } from '../Link';

interface IOffersHeaderProps {
  fromDeveloperPropsCountDisplay: string;
  fromDeveloperPropsCountUrl: string;
  newbuildingName: string;
  onLinkClick(): void;
  salesStartInfo?: React.ReactNode;
}

export function OffersHeader({
  fromDeveloperPropsCountDisplay,
  fromDeveloperPropsCountUrl,
  newbuildingName,
  onLinkClick,
  salesStartInfo,
}: IOffersHeaderProps) {
  return (
    <div data-nav-tab="filter/Квартиры" id="filter" className={styles['nav_container']}>
      <div className={styles['container']}>
        <ArticleHeading1 as="h2" color="text-primary-default">
          {fromDeveloperPropsCountDisplay ? (
            <Link url={fromDeveloperPropsCountUrl} target="blank" onClick={onLinkClick}>
              {fromDeveloperPropsCountDisplay}
            </Link>
          ) : (
            'Объекты'
          )}
          {` в ${newbuildingName}`}
        </ArticleHeading1>
        {salesStartInfo && <div className={styles['sales-start']}>{salesStartInfo}</div>}
      </div>
    </div>
  );
}
